import {Button, Card, Col, Form, Pagination, Row} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {IResultsJson} from '../../oneLead/oneleadTypes'
import {useState} from 'react'
import {ModalInfoPlan} from './ModalInfoPlan'
import {useDisclourse} from '../../../hooks/useDisclourse'
import Lottie from 'lottie-react'
import endLottie from '../../../assets/lotties/end-quotes.json'
import {SIZE_PAGE_QUICK_QUOTE} from '../../../helpers/consts'
import {PaginationUtils} from '../../shared/PaginationUtils'
import {IForm} from '../oneQuoteTypes'

interface IResultProps {
  result: IResultsJson
  loadMoreQuotes: (pag: number, order?: string) => void
  orderQuery: string
  currentPage: number
  updatePage: (n: number) => void
  onSelectPlan?: (plan: any) => void
  queryData?: IForm
}

export const ResultsCards = ({
  result,
  orderQuery,
  loadMoreQuotes,
  currentPage,
  updatePage,
  onSelectPlan,
  queryData,
}: IResultProps) => {
  const intl = useIntl()
  const space = ' '
  const notRecorded = 'N/R'
  const dollar = '$'
  const dot = '.'
  const [infoPlan, setInfoPlan] = useState<null | IResultProps['result']['plans'][0]>(null)
  const {isOpen, onClose, onOpen} = useDisclourse()

  if (result.error) {
    return (
      <div>
        <FormattedMessage id='quotes.plan.noFoundData' defaultMessage='No found data' />
      </div>
    )
  }
  const totalPages = Math.ceil(result.total / SIZE_PAGE_QUICK_QUOTE)

  const {start, end} = PaginationUtils.getPaginationRange(
    currentPage,
    SIZE_PAGE_QUICK_QUOTE,
    result.total
  )

  return (
    <>
      <div className='mt-6'>
        <div className='results-header'>
          <div className='pagination-container'>
            <Pagination size='sm'>
              {/* Botón "Anterior" */}
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => {
                  if (currentPage > 1) {
                    updatePage(currentPage - 1)
                    loadMoreQuotes(currentPage - 1)
                  }
                }}
              />

              {/* Siempre mostrar el número 1 */}
              <Pagination.Item
                active={currentPage === 1}
                onClick={() => {
                  if (currentPage !== 1) {
                    updatePage(1)
                    loadMoreQuotes(1)
                  }
                }}
              >
                {1}
              </Pagination.Item>

              {/* Mostrar puntos suspensivos si hay páginas superiores a 2 */}
              {currentPage > 3 && <Pagination.Ellipsis disabled />}

              {/* Mostrar el rango de páginas visibles */}
              {PaginationUtils.getVisiblePages(currentPage, totalPages)
                .slice(1)
                .map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => {
                      if (page !== currentPage) {
                        updatePage(page)
                        loadMoreQuotes(page)
                      }
                    }}
                  >
                    {page}
                  </Pagination.Item>
                ))}

              {/* Botón "Siguiente" */}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => {
                  if (currentPage < totalPages) {
                    updatePage(currentPage + 1)
                    loadMoreQuotes(currentPage + 1)
                  }
                }}
              />
            </Pagination>
            <div className='pagination-text'>
              <FormattedMessage
                id='quotes.plan.showing'
                defaultMessage='Showing {start} to {end} of {total} plans'
                values={{start, end, total: result.total}}
              />
            </div>
          </div>
          <div className='col-md-3'>
            <div className='results-filter'>
              {/* <Form.Select aria-label='Default select example'>
              <option>Open this select menu</option>
              <option value='1'>One</option>
              <option value='2'>Two</option>
              <option value='3'>Three</option>
            </Form.Select> */}
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id='quotes.plan.order' defaultMessage='Order' />
                  </Form.Label>
                  <Form.Control
                    as='select'
                    name='order'
                    value={orderQuery}
                    onChange={(e) => {
                      console.log('orderQuery', orderQuery)
                      console.log('e.target.value', e.target.value)
                      if (e.target.value === orderQuery) return
                      e.preventDefault()
                      updatePage(1)
                      loadMoreQuotes(1, e.target.value)
                    }}
                  >
                    <option value='asc'>{intl.formatMessage({id: 'quotes.plan.ascending', defaultMessage: 'Ascending'})}</option>
                    <option value='desc'>{intl.formatMessage({id: 'quotes.plan.descending', defaultMessage: 'Descending'})}</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </div>
          </div>
        </div>
        <div className='mt-4 results-cards'>
          {result.plans.map((plan) => (
            <Card className='rounded-1 mb-4' key={plan.id}>
              <Card.Header className='align-items-center'>
                <Card.Title>{plan.issuer.name}</Card.Title>
                <div className='d-flex gap-2'>
                  <Button
                    variant='secondary'
                    size='sm'
                    onClick={() => {
                      onOpen()
                      setInfoPlan(plan)
                    }}
                  >
                    <i className='bi bi-search' />
                    <FormattedMessage id='quotes.plan.details' defaultMessage='PLAN DETAILS' />
                  </Button>
                  <Button
                    variant='primary'
                    size='sm'
                    onClick={() => {
                      onSelectPlan?.(plan)
                    }}
                  >
                    <i className='bi bi-check-circle' />
                    <FormattedMessage id='quotes.plan.select' defaultMessage='SELECT PLAN' />
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <h4 className='text-info fs-3'>{plan.name}</h4>
                <div
                  className='d-flex align-items-center mb-1 flex-wrap'
                  style={{fontSize: '11px'}}
                >
                  <span>{plan.metal_level}</span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span>{plan.type}</span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span>
                    <span className='fw-bold'><FormattedMessage id='quotes.plan.id' defaultMessage='Plan ID:' /></span> {plan.id}
                  </span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span>
                    <span className='fw-bold'><FormattedMessage id='quotes.plan.rating' defaultMessage='Rating:' /></span>{space}
                    {plan.quality_rating.global_rating > 0 &&
                      [1, 2, 3, 4, 5].map((n) => (
                        <i
                          className='bi bi-star-fill'
                          key={n}
                          style={{
                            color: n <= plan.quality_rating.global_rating ? '#da9400' : '#565454',
                          }}
                        />
                      ))}
                    {plan.quality_rating.global_rating === 0 && (
                      <span> {plan.quality_rating.global_not_rated_reason}</span>
                    )}
                  </span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span className='d-flex align-items-center'>
                    <span className='fw-bold'><FormattedMessage id='quotes.plan.dentalAdults' defaultMessage='Dental adults:' /></span>{space}
                    {plan.benefits.find((p) => p.type === 'BASIC_DENTAL_CARE_ADULT')?.covered ? (
                      <i className='bi bi-check fs-2' style={{color: 'green'}} />
                    ) : (
                      <i className='bi bi-x fs-2' style={{color: 'red'}} />
                    )}
                  </span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span className='d-flex align-items-center'>
                    <span className='fw-bold'><FormattedMessage id='quotes.plan.dentalChildren' defaultMessage='Dental children:' /></span>{space}
                    {plan.benefits.find((p) => p.type === 'DENTAL_CHECK_UP_FOR_CHILDREN')
                      ?.covered ? (
                      <i className='bi bi-check fs-2' style={{color: 'green'}} />
                    ) : (
                      <i className='bi bi-x fs-2' style={{color: 'red'}} />
                    )}
                  </span>
                </div>
                <div className='d-flex  gap-1 flex-wrap flex-column flex-lg-row'>
                  <Card className='cards-benefits' style={{flex: 1}}>
                    <Card.Body>
                      <div>
                        <span className='fs-6 fw-bold'><FormattedMessage id='quotes.plan.monthlyPremium' defaultMessage='Monthly premium:' /></span>
                      </div>
                      <div>
                        <span className='fs-2 fw-bold'>
                          <small>
                            <sup>{dollar}</sup>
                          </small>
                          {Math.floor(Number(plan.premium_w_credit))}
                          <small>
                            <sup>{dot}{Number(plan.premium_w_credit).toFixed(2).slice(-2)}</sup>
                          </small>
                        </span>
                      </div>
                      <p className='m-0 p-0 text-muted'>
                        <FormattedMessage id='quotes.plan.savingsTotal' defaultMessage='Savings total:' />{space}
                        <span className='text-success fw-bold'>
                          {Number(Number(plan.premium) - Number(plan.premium_w_credit)).toFixed(2)}
                        </span>
                      </p>
                      <p className='m-0 p-0 text-muted'>
                        <FormattedMessage id='quotes.plan.planWas' defaultMessage='Plan was:' /> <span className='text-danger fw-bold'>{plan.premium}</span>
                      </p>
                    </Card.Body>
                  </Card>
                  <Card className='cards-benefits' style={{flex: 1}}>
                    <Card.Body>
                      <div>
                        <span className='fs-6 fw-bold'><FormattedMessage id='quotes.plan.deductibleShort' defaultMessage='Deductible' /></span>
                      </div>
                      <div>
                        <span className='fs-2 fw-bold'>
                          <small>
                            <sup>{dollar}</sup>
                          </small>
                          {Math.floor(Number(plan.deductibles?.[0]?.amount))}
                        </span>
                      </div>
                      <p className='m-0 p-0 text-muted'>
                        {plan.deductibles?.[0]?.family_cost || ''}{space}
                        <FormattedMessage id='quotes.plan.total' defaultMessage='total' />
                        {plan.deductibles?.[1]?.amount && (
                          <FormattedMessage
                            id='quotes.plan.perPerson'
                            defaultMessage=' (${amount} per person)'
                            values={{amount: plan.deductibles[1].amount || notRecorded}}
                          />
                        )}
                      </p>
                      <p className='m-0 p-0 text-muted'> {plan.deductibles?.[0]?.type || notRecorded}</p>
                    </Card.Body>
                  </Card>
                  <Card className='cards-benefits' style={{flex: 1}}>
                    <Card.Body>
                      <div>
                        <span className='fs-6 fw-bold'><FormattedMessage id='quotes.plan.outOfPocketMax' defaultMessage='Out-of-pocket max:' /></span>
                      </div>
                      <div>
                        <span className='fs-2 fw-bold'>
                          {plan.moops
                            ?.filter(
                              (moop) =>
                                moop.type ===
                                'Maximum Out of Pocket for Medical and Drug EHB Benefits (Total)'
                            )
                            ?.sort((a, b) => (b.family ? 1 : 0) - (a.family ? 1 : 0)) // Priorizar family: true
                            ?.find(() => true)?.amount || notRecorded}
                        </span>
                      </div>

                      <p className='m-0 p-0 text-muted'>
                        {plan.moops
                          ?.filter(
                            (moop) =>
                              moop.type ===
                              'Maximum Out of Pocket for Medical and Drug EHB Benefits (Total)'
                          )
                          ?.sort((a, b) => (b.family ? 1 : 0) - (a.family ? 1 : 0)) // Priorizar family: true
                          ?.find(() => true)?.family
                          ? intl.formatMessage({id: 'quotes.plan.familyTotal', defaultMessage: 'Family total'})
                          : intl.formatMessage({id: 'quotes.plan.individualTotal', defaultMessage: 'Individual total'})}
                      </p>

                      <p className='m-0 p-0 text-muted'>
                        {plan.moops
                          ?.filter(
                            (moop) =>
                              moop.type ===
                              'Maximum Out of Pocket for Medical and Drug EHB Benefits (Total)'
                          )
                          ?.sort((a, b) => (b.family ? 1 : 0) - (a.family ? 1 : 0)) // Priorizar family: true
                          ?.find(() => true)
                          ?.type?.replace('Out of Pocket', '') || notRecorded}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              </Card.Body>
              <Card.Footer>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5><FormattedMessage id='quotes.plan.primaryDoctor' defaultMessage='Primary Doctor visits' /></h5>
                    <p>
                      {plan.benefits.find(
                        (p) => p.type === 'PRIMARY_CARE_VISIT_TO_TREAT_AN_INJURY_OR_ILLNESS'
                      )?.cost_sharings?.[0]?.display_string || notRecorded}
                    </p>
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5><FormattedMessage id='quotes.plan.specialistVisits' defaultMessage='Specialist Visits' /></h5>

                    {(() => {
                      const inNetwork = plan.benefits
                        .find((p) => p.type === 'SPECIALIST_VISIT')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'In-Network')

                      const outNetwork = plan.benefits
                        .find((p) => p.type === 'SPECIALIST_VISIT')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'Out-of-Network')

                      if (inNetwork?.display_string === outNetwork?.display_string) {
                        return <div>{inNetwork?.display_string || notRecorded}</div>
                      }
                      // Si uno de los valores es "Not Covered", mostrar solo el otro
                      if (inNetwork?.display_string === 'Not Covered') {
                        return <div>{outNetwork?.display_string || notRecorded}</div>
                      }

                      if (outNetwork?.display_string === 'Not Covered') {
                        return <div>{inNetwork?.display_string || notRecorded}</div>
                      }

                      return (
                        <>
                          {inNetwork ? (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.inNetwork' defaultMessage='In-Network:' /></strong> {inNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.inNetwork' defaultMessage='In-Network:' /></strong> {notRecorded}
                            </div>
                          )}
                          {outNetwork ? (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.outOfNetwork' defaultMessage='Out-of-Network:' /></strong> {outNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.outOfNetwork' defaultMessage='Out-of-Network:' /></strong> {notRecorded}
                            </div>
                          )}
                        </>
                      )
                    })()}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                    <h5><FormattedMessage id='quotes.plan.urgentCare' defaultMessage='Urgent care' /></h5>

                    {(() => {
                      const inNetwork = plan.benefits
                        .find((p) => p.type === 'URGENT_CARE_CENTERS_OR_FACILITIES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'In-Network')

                      const outNetwork = plan.benefits
                        .find((p) => p.type === 'URGENT_CARE_CENTERS_OR_FACILITIES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'Out-of-Network')

                      if (inNetwork?.display_string === outNetwork?.display_string) {
                        return <div>{inNetwork?.display_string || notRecorded}</div>
                      }
                      // Si uno de los valores es "Not Covered", mostrar solo el otro
                      if (inNetwork?.display_string === 'Not Covered') {
                        return <div>{outNetwork?.display_string || notRecorded}</div>
                      }

                      if (outNetwork?.display_string === 'Not Covered') {
                        return <div>{inNetwork?.display_string || notRecorded}</div>
                      }

                      return (
                        <>
                          {inNetwork ? (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.inNetwork' defaultMessage='In-Network:' /></strong> {inNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.inNetwork' defaultMessage='In-Network:' /></strong> {notRecorded}
                            </div>
                          )}
                          {outNetwork ? (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.outOfNetwork' defaultMessage='Out-of-Network:' /></strong> {outNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.outOfNetwork' defaultMessage='Out-of-Network:' /></strong> {notRecorded}
                            </div>
                          )}
                        </>
                      )
                    })()}

                    {/* <p>
                      {plan.benefits.find((p) => p.type === 'URGENT_CARE_CENTERS_OR_FACILITIES')
                        ?.cost_sharings?.[0]?.display_string || notRecorded}
                    </p> */}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5><FormattedMessage id='quotes.plan.mentalHealth' defaultMessage='Mental health' /></h5>

                    {(() => {
                      const inpatient = plan.benefits.find(
                        (p) => p.type === 'MENTAL_BEHAVIORAL_HEALTH_INPATIENT_SERVICES'
                      )?.cost_sharings?.[0]?.display_string

                      const outpatient = plan.benefits.find(
                        (p) => p.type === 'MENTAL_BEHAVIORAL_HEALTH_OUTPATIENT_SERVICES'
                      )?.cost_sharings?.[0]?.display_string

                      if (inpatient || outpatient) {
                        return (
                          <>
                            {inpatient && (
                              <div>
                                <strong><FormattedMessage id='quotes.plan.inpatient' defaultMessage='Inpatient:' /></strong> {inpatient}
                              </div>
                            )}
                            {outpatient && (
                              <div>
                                <strong><FormattedMessage id='quotes.plan.outpatient' defaultMessage='Outpatient:' /></strong> {outpatient}
                              </div>
                            )}
                          </>
                        )
                      } else {
                        return notRecorded
                      }
                    })()}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5><FormattedMessage id='quotes.plan.emergencies' defaultMessage='Emergencies' /></h5>

                    {(() => {
                      const inNetwork = plan.benefits
                        .find((p) => p.type === 'EMERGENCY_ROOM_SERVICES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'In-Network')

                      const outNetwork = plan.benefits
                        .find((p) => p.type === 'EMERGENCY_ROOM_SERVICES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'Out-of-Network')

                      if (inNetwork?.display_string === outNetwork?.display_string) {
                        return <div>{inNetwork?.display_string || notRecorded}</div>
                      }

                      return (
                        <>
                          {inNetwork ? (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.inNetwork' defaultMessage='In-Network:' /></strong> {inNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.inNetwork' defaultMessage='In-Network:' /></strong> {notRecorded}
                            </div>
                          )}
                          {outNetwork ? (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.outOfNetwork' defaultMessage='Out-of-Network:' /></strong> {outNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong><FormattedMessage id='quotes.plan.outOfNetwork' defaultMessage='Out-of-Network:' /></strong> {notRecorded}
                            </div>
                          )}
                        </>
                      )
                    })()}

                    {/* <p>
                      {plan.benefits.find((p) => p.type === 'EMERGENCY_ROOM_SERVICES')
                        ?.cost_sharings?.[0]?.display_string || notRecorded}
                    </p> */}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                    <h5><FormattedMessage id='quotes.plan.genericDrugs' defaultMessage='Generic drugs' /></h5>
                    <p>
                      {plan.benefits.find((p) => p.type === 'GENERIC_DRUGS')?.cost_sharings?.[0]
                        ?.display_string || notRecorded}
                    </p>
                  </Col>
                </Row>
              </Card.Footer>
            </Card>
          ))}
          {result.plans.length === 0 && (
            <Card>
              <Card.Header>
                <Card.Title><FormattedMessage id='quotes.plan.noMorePlans' defaultMessage='There are no more plans' /></Card.Title>
              </Card.Header>
              <Card.Body>
                <div className='d-flex align-items-center justify-content-center'>
                  <Lottie
                    animationData={endLottie}
                    autoPlay
                    style={{maxWidth: '50%', borderRadius: '60px', overflow: 'hidden'}}
                  />
                </div>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>
      {infoPlan && isOpen && (
        <ModalInfoPlan
          isOpen={isOpen}
          onClose={onClose}
          onSave={onSelectPlan}
          planInput={infoPlan}
          queryData={queryData}
          planId={infoPlan.id}
        />
      )}
    </>
  )
}
